module.exports = __webpack_public_path__ + "marks.5ca7c2c290687c42cc69.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/employees/marks.jpg
// module id = ../../../../../src/assets/employees/marks.jpg
// module chunks = 0